type OrderType = 'delivery' | 'pickup' | 'pickupDelivery' | 'multiOrder'

interface ResellerCsvSettings {
    settings?: {
        orders?: {
            csvColumns?: Record<string, string[]>
            csvColumnsPerOrderType?: Record<string, Partial<Record<OrderType, string[]>>>
        }
    }
}

// The stored CSV import column layout of a customer for an order type, falling back to the customer's layout without order type
export function getOrderCsvColumns(reseller: ResellerCsvSettings | undefined, customerId: string, orderType: OrderType): string[] {
    const orders = reseller?.settings?.orders

    return orders?.csvColumnsPerOrderType?.[customerId]?.[orderType] || orders?.csvColumns?.[customerId] || []
}

// Replaces the current layout completely; with a loaded file the layout keeps the file's number of columns
export function applyCsvColumns(currentColumns: string[], savedColumns: string[], fileLoaded: boolean): string[] {
    return fileLoaded ? currentColumns.map((value, index) => savedColumns[index] || '') : [...savedColumns]
}
